import React from 'react'
import { IoInformationCircleOutline } from 'react-icons/io5'

export function LabelActionGuide({ title, children }) {
    return (
        <div className="mb-3 flex gap-2 border border-slate-200 bg-slate-50 p-2.5">
            <IoInformationCircleOutline className="mt-0.5 h-4 w-4 shrink-0 text-slate-600" aria-hidden="true" />
            <div className="min-w-0 text-xs leading-5 text-slate-700">
                <div className="font-semibold text-slate-800">{title}</div>
                <div>{children}</div>
            </div>
        </div>
    )
}

function ShareWithOrg(props) {
    const {
        value = "",
        onChange = () => { },
        placeholder = "",
        label,
        guidanceTitle,
        guidance,
    } = props
    return (
        <div className="w-full py-1">
            {guidance && <LabelActionGuide title={guidanceTitle}>{guidance}</LabelActionGuide>}
            <label className="block w-full text-xs font-medium text-slate-700">
                {label && <span className="mb-1 block">{label}</span>}
                <input
                    className="block w-full h-8 px-3 text-xs text-slate-800 border border-slate-300 rounded-none outline-none focus:border-blue-600 transition-colors"
                    type="text"
                    placeholder={placeholder}
                    aria-label={label || placeholder}
                    value={value}
                    onChange={onChange}
                />
            </label>
        </div>
    )
}
export default ShareWithOrg
